<template></template>

<script>
export default {
    mounted() {
        document.addEventListener('DOMContentLoaded', function (event) {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
                event: 'purchase',
                ecommerce: {
                    currency: 'SEK',
                    value: '0',
                    tax: '0',
                    shipping: 0,
                    transaction_id: 0,
                    items: [
                        {
                            item_name: 'bas',
                            item_id: '0',
                            price: '0',
                            quantity: 1
                        }
                    ]
                }
            });
        });
    }
};
</script>
